/*
 * 接口统一集成模块
 */
import * as data from './moudules/data'
import * as cloudservice from './moudules/cloudservice'
import * as login from './moudules/login'
import * as menu from './moudules/menu'
import * as dictionary from './moudules/dictionary'
import * as doctor from './moudules/doctor'
import * as form from './moudules/form'
import * as hospital from './moudules/hospital'
import * as team from './moudules/team'
import * as count from './moudules/count'
import * as video from './moudules/video'

// 默认全部导出
export default {
  data,
  cloudservice,
  login,
  menu,
  dictionary,
  doctor,
  form,
  hospital,
  team,
  count,
  video
}



// WEBPACK FOOTER //
// ./src/http/api.js